import {
  dbui_v1_UpdateObservableRiskRequest,
  dbuiV1UpdateObservableRiskMutation,
} from '@antimatterhq/asl-api-ts-v1';
import { useMutation } from '@antimatterhq/ui/hooks/mutations/useMutation';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { useWarehouseLocation } from '@/contexts/WarehouseLocationContext';
import { defaultOptions } from '@/utils/query';
export const useUpdateRiskScore = ({
  kind,
  value,
}: {
  kind: string;
  value: string;
}) => {
  const { workspace } = useWorkspace();
  const { selectedWarehouse } = useWarehouseLocation();
  const warehouse = selectedWarehouse?.id || '';
  return useMutation({
    mutationFn: (data: dbui_v1_UpdateObservableRiskRequest) =>
      dbuiV1UpdateObservableRiskMutation({
        ...defaultOptions(),
      }).mutationFn!({
        body: data,
        path: { workspace, kind, value },
        query: { warehouse },
      }),
  });
};
